export default __webpack_public_path__ + "static/media/logo-engie-blue.a89d73a9.svg";